<template>
  <div class="login-page">
    <div class="login-right">
      <div class="loginContent">
          <p class="tip">IPFS HARBOR admin</p>
          <p class="title">
            <i class="logo"></i>
            <span>星际港湾</span>
          </p>
          <el-form :model="ruleForm"  :rules="rules" ref="ruleForm" class="demo-ruleForm" label-width="0px" style="width:70%;margin:0 auto;">
            <el-form-item label="" prop="userAccount">
              <el-input placeholder="请输入您的账号" v-model.trim="ruleForm.userAccount" autocomplete="off" @keyup.enter.native="handleSubmit">
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="pass">
              <el-input type="password" placeholder="请输入账户密码" v-model.trim="ruleForm.pass" autocomplete="off" @keyup.enter.native="handleSubmit">
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="code">
              <div class="code_box">
                <el-input type="text" @input="ruleForm.code = String(ruleForm.code).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/" placeholder="请输入验证码" v-model.trim="ruleForm.code" autocomplete="off" @keyup.enter.native="handleSubmit"></el-input>
                <!-- <el-input-number :controls='false' placeholder="请输入验证码"  v-model.trim="ruleForm.code" autocomplete="off" @keyup.enter.native="handleSubmit"></el-input-number> -->
                <div class="codeBox" v-show="show" @click="codeFunc" style="cursor: pointer;">获取验证码</div>
                <div class="codeBox" v-show="!show">{{count+'s'}}</div>
              </div>
            </el-form-item>
            <p class="loginbtn" @click="handleSubmit">登 录</p>
          </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import selfFunc from '@/utils/common'
export default {
  data() {
    var codeYz = (rule, value, callback) => {
      console.log(value)
      let reg = /^[0-9]*[1-9][0-9]*$/
      if(!reg.test(this.value)){
        console.log(1)
      }
      if (value === '') {
        callback(new Error('请输入验证码'));
      } else if (value<0) {
        this.ruleForm.code = undefined
        callback(new Error('请输入验证码'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        userAccount: "",
        pass: "",
        code: undefined,
        type: 1,
        loginChannel: 2
      },
      rules: {
        userAccount: [
          { required: true, message: "账号不能为空", trigger: "blur" }
        ],
        pass: [{ required: true, message: "密码不能为空", trigger: "blur" }],
        code: [{ required: true, message: "验证码不能为空", trigger: "blur" }]
        
      },
      show: true,
      count: '',
      timer: null,
      iphone: ''
    };
  },
  created() {
    sessionStorage.clear()
    localStorage.clear()
    selfFunc.delCookie('login')
  },
  methods: {
    async codeFunc (){
      //  获取验证码
      // if (!this.userName()) { return false }
      let res = await this.$http.sendIphoneCode({
        userAccount: this.ruleForm.userAccount
      })
      if (res) {
        this.iphone = res.data
        this.getCode()
      }
    },
    //  获取验证码
    getCode:selfFunc.throttle(async function(){
      let self = this
      let res = await this.$http.sendVerifyCode({
        contactLink: self.iphone,
        type: 1,
        msgType: 2,
      })
      if (res) {
        self.$message({
          message: '验证码已发送',
          type: 'success'
        });
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
            }
          }, 1000)
        }
      } else {
        this.show = true;
      }
    },4000),
    handleSubmit() {
      console.log(this.ruleForm)
      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          let res = await this.$http.login({...this.ruleForm});
          if (res) {
            let userToken=res.data.token
            sessionStorage.setItem("userToken", JSON.stringify(userToken));
            // window.location.href = '/'
            this.$router.push({path:'/',query:{loginEnter:true}})
          }
        }
      });
    }
  }
};
</script>

<style lang="scss">
.login-page {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  // background: #F3F4F8;
  background: url('../assets/img/blur-bg.jpg') no-repeat;
  background-size: 100% 100%;
    .login-left{
      position: relative;
      width: 62%;
      height: 100%;
      .logo1{
        margin-top: 70px;
        margin-left: 5%;
        width: 107px;
      }
      .img1{
       position: absolute;
       left: 0;
       bottom: 0;
       width: 100%;
       height: 154px;
      }
      .img2{
        position: absolute;
        width: 90%;
        max-width: 850px;
        bottom: 56px;
        left: 50%;
        transform:translateX(-50%);
      }
    }
    .login-right {
      width: 540px;
      margin: 0 auto;
      border-radius: 5px;
      background: rgba(0,0,0,.55);
      color: #fff;
      padding: 32px;
      .loginContent{
        width: 100%;
      }
      .logo2 {
        height:166px;
        margin-bottom: 15px;
      }
      .tip{
        font-size: 30px;
        color: #fff;
        font-weight: bold;
        margin-bottom: 10px;
        text-align: center;
      }
      .title{
        font-size: 20px;
        color:#209e91;
        text-align: center;
        margin-bottom: 20px;
        .logo{
          display: inline-block;
          width: 40px;
          height: 20px;
          background: url('../assets/img/logo.png') no-repeat;
          background-size: 100% 100%;
          position: relative;
          top: 2px;
          right: 20px;
        }
      }
      .ivu-input {
        position: relative;
        background: #fff;
        height: 50px;
        border-radius: 0;
        padding: 0 20px;
        border: none;
        padding-left: 45px;
        border-bottom: 1px solid #eeeeee;
        &:focus {
          box-shadow: none;
        }
      }
      .ivu-form-item-error-tip{color: #8e9198 !important;}
      input:-webkit-autofill {
        box-shadow: 0 0 0px 1000px #f7f9fb inset;
      }
      .icon {
        position: absolute;
        left: 0;
        top: 8px;
      }
      .icon1 {
        width: 25px;
        height: 30px;
        background-size: contain;
      }
      .icon2 {
        width: 22px;
        height: 29px;
        background-size: contain;
      }
      .loginbtn {
        background: #209e91;
        box-shadow: 0px 17px 21px 0px rgba(152, 173, 241, 0.44);
        border-radius: 20px;
        height: 33px;
        line-height: 33px;
        text-align: center;
        width: 110px;
        font-size: 13px;
        margin: 40px auto 0;
        display: block;
        color: #fff;
        cursor: pointer;
        transition: all .1s;
      }
      .loginbtn:hover{
        background: #209e91;
        border-color: #209e91;
        transform: scale(1.3);
        transition: all .1s;
      }
    }
}
</style>
<style>
.login-page .el-form-item.is-error .el-input__inner{
  border-color: #8e9198;
}
.login-page .el-form-item__error {
    color: #F56C6C !important;
}
.code_box .el-input__inner{
  border: none;
}
</style>
<style scoped>
.code_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  background: #fff;
  border-radius: 4px;
  padding-right: 10px;
}
.codeBox{
  width: 80px;
  height: 27px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  background: #36A36B;
  border-radius: 2px;
  border: 1px solid #36A36B;
  font-size: 12px;
}
</style>